// extracted by mini-css-extract-plugin
var _1 = "RequestCreateButton-modulemobileSize__bPUyE";
export { _1 as "mobileSize" }
